module.exports = new __parcel__URL__("library_hero.152204f6.png").toString();